import React from 'react'
import './Footer.css'

function Footer() {
  return (
    <footer className="modern-footer">
      <div className="footer-content">
        <div className="container">
          <div className="row justify-content-center">
            {/* Company Info Section */}
            <div className="col-lg-6 col-md-8 mb-4">
              <div className="footer-section">
                <div className="footer-logo">
                  <i className="fa fa-shuttle-cock fa-2x text-warning mb-3"></i>
                  <h5 className="footer-title">Play Badminton</h5>
                </div>
                <p className="footer-description">
                  Your premier badminton booking platform in Maribyrnong. 
                  Experience world-class facilities and professional coaching.
                </p>
                <div className="footer-contact">
                  <div className="contact-item">
                    <i className="fa fa-phone text-primary me-2"></i>
                    <span>0498623111</span>
                  </div>
                  <div className="contact-item">
                    <i className="fa fa-envelope text-success me-2"></i>
                    <span>admin@playbadminton.com.au</span>
                  </div>
                  <div className="contact-item">
                    <i className="fa fa-map-marker text-danger me-2"></i>
                    <span>Maribyrnong College, Victoria</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Social & Developer Section */}
            <div className="col-lg-6 col-md-8 mb-4">
              <div className="footer-section">
                <h6 className="footer-section-title">Connect With Us</h6>
                <div className="social-links">
                  <a href="https://www.facebook.com/PlayBadmintonMaribyrnong?mibextid=ZbWKwL" 
                     className="social-link facebook" 
                     target="_blank" 
                     rel="noopener noreferrer"
                     title="Follow us on Facebook">
                    <i className="fa-brands fa-facebook"></i>
                  </a>
                  <a href="https://www.instagram.com/play_badminton/?igsh=MXUybzFsNDlkdndscw%3D%3D" 
                     className="social-link instagram" 
                     target="_blank" 
                     rel="noopener noreferrer"
                     title="Follow us on Instagram">
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                  <a href="mailto:admin@playbadminton.com.au" 
                     className="social-link email"
                     title="Send us an email">
                    <i className="fa fa-envelope"></i>
                  </a>
                  <a href="tel:0498623111" 
                     className="social-link phone"
                     title="Call us">
                    <i className="fa fa-phone"></i>
                  </a>
                </div>
                
                <div className="developer-info">
                  <p className="developer-text">
                    <i className="fa fa-code me-2"></i>
                    Developed by
                  </p>
                  <a href="https://www.appsmartcorporation.com/" 
                     target="_blank" 
                     rel="noopener noreferrer"
                     className="developer-link">
                    <i className="fa fa-external-link me-1"></i>
                    Appsmart IT Corporation
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 text-center text-md-start">
              <p className="copyright">
                &copy; {new Date().getFullYear()} Play Badminton Maribyrnong. All rights reserved.
              </p>
            </div>
            <div className="col-md-6 text-center text-md-end">
              <p className="footer-tagline">
                <i className="fa fa-heart text-danger me-1"></i>
                Made with passion for badminton
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer